import { Component, OnInit } from '@angular/core';

import { NceService } from '../services/nce.service';

import { PageNavigationService } from '../../shared/services/page-navigation.service';
import { LayoutService } from '../../shared/services/layout.service';
import { PopupService } from 'app/shared/services/pop-up.service';

import { STATIC_VALUE } from '../../shared/configuration/static.value';

@Component({
    selector: 'nce-payment',
    templateUrl: 'payment.component.html'
})

export class NcePaymentComponent implements OnInit{

    isBoxShow = true;

    constructor(
        private _nceService: NceService,
        private _layoutService: LayoutService, 
        private _pageNavigationService: PageNavigationService,
        private _popupService: PopupService
    ) {
        
    }

    ngOnInit() {
    	this._layoutService.setCurrentPage('nce-payment');
        this._nceService.resetNCEData();
        this._nceService.resetPaymentData();
        this.isBoxShow = false;
        this._nceService.checkPaymentCredential().then(
            (resolve) => {
                this.isBoxShow = true;
                if(this.getPaymentData().payment_credential){
                    this.isBoxShow = false;
                    this._nceService.loadNCEPrice().then(
                        (resolve) => {
                            this.isBoxShow = true;
                            this.checkIsPaymentPending();
                        },
                        (reject) => {
                            // this.isBoxShow = true;
                        }
                    );
                }
            },
            (reject) => {
                
            }
        );
    }

    isLoading(){
        return this._nceService.isLoading();
    }

    getPaymentData(){
        return this._nceService.getPaymentData();
    }

    getRequestID(){
        return this._nceService.vNCEData.nce_request_id || this._nceService.vDetailNCE.nce_request_id || this._nceService.vNCEID.nce_request_id;
    }

    isDisableSubmit(){
        return this._nceService.isDisablePayment();
    }

    checkIsPaymentPending() {
        if(this._nceService.getIsPaymentPending() === true) {
            this._popupService.openGeneralConfirmationPopup('Notice', 'Your payment was unsuccessful, please try again.', '', false, false);
            this._nceService.setIsPaymentPending(false);
        }
    }

    submitPayment(){
        this._nceService.submitPayment();
    }

    goBack(){
        let vLink = ['nce-application/preview'];
        this._pageNavigationService.navigate(vLink);
    }

    getPaymentMethod() {
		return STATIC_VALUE.PAYMENT_METHOD;
    }
}


// WEBPACK FOOTER //
// /home/maheshreddy/PRP_FE/src/app/nce/components/payment.component.ts